module.exports = __webpack_public_path__ + "img/pexels-burst-374897.fc7fb232.jpg";